// This file was generated by lezer-generator. You probably shouldn't edit it.
export const Number = 1,
  Duration = 2,
  ExistsOperator = 3,
  LogicalOperator = 4,
  InclusionOperator = 5,
  SearchOperator = 6,
  PositionOperator = 7,
  InvalidPositionOperator = 8,
  String = 9,
  IncompleteString = 10,
  FreeText = 11,
  JsonPathIdentifier = 12,
  KeyIdentifier = 13,
  ValueIdentifier = 14,
  ValueBoolean = 15,
  ListIdentifier = 16,
  ListBoolean = 17,
  Filter = 18,
  FilterGroup = 19,
  OpeningBracket = 20,
  FilterStatement = 21,
  FilterKey = 22,
  InvalidIdentifier = 23,
  Variable = 24,
  JsonPath = 25,
  JsonPathBase = 26,
  Identifier = 27,
  JsonPathSeparator = 28,
  JsonPathArray = 29,
  JsonPathNameSelector = 30,
  JsonPathSquareOpeningBracket = 31,
  JsonPathSquareClosingBracket = 32,
  ComparisonOperator = 33,
  InvalidComparisonOperator = 34,
  FilterSimpleValue = 35,
  FilterIncludesValue = 36,
  List = 37,
  ClosingBracket = 38,
  ListValue = 39,
  InvalidInclusionValue = 40;
